<template>
	<div class="SentOrderUpdatePopUp">
		<div class="flex justify-between items-end mb-4">
			<h3 class="capitalize">{{ orderToUpdate.outlet_info.name }} Store</h3>
			<!-- <h3>Items to Order</h3> -->
			<div>
				<h4 class="mb-2">Created On</h4>
				<p>{{orderToUpdate.created_on}}</p>
			</div>
			<div>
				<h4 class="mb-2">Delivery Date</h4>
				<p>{{ orderToUpdate.date_estimated }}</p>
			</div>
			<!-- <div>
				<h4 class="mb-2">Delivery Time</h4>
				<p>12PM To 6PM</p>
			</div> -->

			<div>
				<!-- <BaseButton
						:disabled="isOrderDisabled"
						buttonclass="btn p-1 text-xs"
						@click="cancelOrder"
					>
						Cancel Order
					</BaseButton> -->
				<p class="mb-1">Order Status</p>
				<el-select
					v-model="orderStatus"
					style="min-width: 100%"
					size="small"
					placeholder="Update Order Status"
					@change="checkStatus(orderStatus)"
				>
					<!-- @change="orderStatusUpdate" -->
					<el-option
						v-for="(status, statusIndex) in orderStatusOptions[
							orderToUpdate.status
						]"
						:key="statusIndex"
						:label="status.label"
						:value="status.value"
					></el-option>
					<!-- <el-option value="created" label="Created" />
						<el-option value="sent" label="Sent" />
						<el-option value="accepted" label="Accepted" />
						<el-option value="dispatched" label="Dispatched" />
						<el-option value="recieved_open" label="Recieved Open" />
						<el-option value="recieved_closed" label="Recieved Closed" />
						<el-option value="cancelled" label="Cancelled" /> -->
				</el-select>
			</div>
		</div>
		<simplebar class="simplebar pb-2">
			<table class="tableMain ">
				<thead>
					<tr>
						<th colspan="1" style="min-width: 100px">
							Item
						</th>
						<th colspan="1" style="min-width: 100px">
							Item Name
						</th>
						<th colspan="1" style="min-width: 100px">
							Order Qty
						</th>
						<th colspan="1" style="min-width: 100px">
							Order Unit
						</th>
						<th colspan="1" style="min-width: 100px">
							Updated Qty
						</th>
						<th colspan="1" style="min-width: 100px">
							Unit Price
						</th>
						<th colspan="1" style="min-width: 100px">
							Updated Price
						</th>
						<th colspan="1" style="min-width: 100px">
							Amount
						</th>
						<th colspan="1" style="min-width: 100px">
							Batch No
						</th>
						<th colspan="1" style="min-width: 100px">
							Expiry Date
						</th>
						<th colspan="1" style="min-width: 100px"></th>
						<!-- <th colspan="2">
							Qty Received
						</th>
						<th colspan="2">
							Variance
						</th>
						<th colspan="1">
							Reason
						</th> -->
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(actualItem, actualItemsIndex) in actualItems"
						:key="actualItemsIndex"
					>
						<td>
							{{ actualItem.item_info.article.code }}
						</td>
						<td class="capitalize">
							{{ actualItem.item_info.article.name }}
						</td>
						<td>
							{{ actualItem.quantity }}
						</td>
						<td>{{ actualItem.unit }}</td>
						<td>
							<BaseInput
								v-model="actualItem.updatedQuantity"
								v-validate="{
									required: actualItem.isItemFromSplit
								}"
								:disabled="enableOnStatusRecievedOpen"
								type="number"
								class="baseInput"
								style="width: 130px"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Updated Qty"
								:name="`Updated Qty + ${actualItem.validationId}`"
							/>
							<span
								:v-show="errors.has(`Updated Qty + ${actualItem.validationId}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Updated Qty + ${actualItem.validationId}`) }}
							</span>
						</td>
						<td>
							<!-- {{ (actualItem.amount / actualItem.quantity).toFixed(2) }} -->
							{{ actualItem.amount }}
						</td>
						<td>
							<BaseInput
								v-model="actualItem.updatedPrice"
								:disabled="isOrderDisabled"
								style="width: 130px"
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Updated Price"
							/>
						</td>
						<td>
							{{ updatedAmount(actualItem) }}
						</td>
						<td>
							<BaseInput
								v-model="actualItem.batch_number"
								v-validate="orderStatus === 'dispatched' ? 'required' : ''"
								:disabled="disableBatchExpiry"
								class="baseInput"
								style="width: 100px"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Batch No"
								:name="`Batch Number + ${actualItem.validationId}`"
							/>
							<span
								:v-show="
									errors.has(`Batch Number + ${actualItem.validationId}`)
								"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Batch Number + ${actualItem.validationId}`) }}
							</span>
						</td>
						<td>
							<el-date-picker
								v-model="actualItem.expiry_date"
								v-validate="orderStatus === 'dispatched' ? 'required' : ''"
								:disabled="disableBatchExpiry"
								:picker-options="datePickerOptions"
								value-format="yyyy-MM-dd"
								type="date"
								placeholder="Expiry Date"
								style="width: 130px;"
								:name="`Expiry Date + ${actualItem.validationId}`"
							/>
							<div
								:v-show="errors.has(`Expiry Date + ${actualItem.validationId}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Expiry Date + ${actualItem.validationId}`) }}
							</div>
						</td>
						<!-- v-if="actualItem.isItemFromSplit === false" -->
						<td>
							<div class="flex SplitOrder">
								<BaseButton
									:disabled="disableBatchExpiry"
									buttonclass="btn p-1 text-xs"
									@click="splitOrder(actualItems, actualItem, actualItemsIndex)"
								>
									Split Order
								</BaseButton>
								<!-- <div class="tooltip">
									?
									<span class="tooltiptext"
										>Split order when more than one batch is supplied for order
										quantity. Please provide updated quanity for each
										batch</span
									>
								</div> -->
								<div>
									<el-popover
										placement="bottom-end"
										width="200"
										trigger="hover"
										style="left:690px !important;word-break: normal !important"
										content="Split order when more than one batch is supplied for order quantity. Please provide updated quanity for each batch"
										class="tooltip"
										popper-class="SentOrderUpdatePopOver"
									>
										<el-button slot="reference">?</el-button>
									</el-popover>
								</div>
								<!-- <BaseButton
								v-else
								buttonclass="btn p-1 text-xs"
								:disabled="isOrderDisabled"
								@click="saveSplittedOrder(actualItem)"
							>
								Save
							</BaseButton> -->
								<!-- isItemFromSplit, => the splitted item key is set to true; toggle save and split on this key; -->

								<!-- <div class="tooltip">
									?
									<span class="tooltiptext">
										Split order when more than one batch is supplied for order
										quantity. Please provide updated quanity for each
										batch</span
									>
								</div> -->
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<!-- <el-row :gutter="20" class="mt-4 mb-8">
			<el-col
				v-if="returnedItems.length"
				:xs="24"
				:sm="24"
				:md="18"
				:lg="18"
				:xl="18"
			>
				<div>
					<h3 class="mb-1">Returned Items</h3>
					<table class="tableMain">
						<thead>
							<tr>
								<th colspan="1" class="border-right">
									Item Code
								</th>
								<th colspan="1" class="border-right">
									Item Name
								</th>
								<th colspan="1" class="border-right">
									Order Qty
								</th>
								<th colspan="1" class="border-right">
									Unit Price
								</th>
								<th colspan="1" class="border-right">
									Amount
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(returnedItem, returnedItemIndex) in returnedItems"
								:key="returnedItemIndex"
							>
								<td>
									{{ returnedItem.item_info.article.code }}
								</td>
								<td>
									{{ returnedItem.item_info.article.name }}
								</td>
								<td>
									{{ returnedItem.quantity }}
								</td>
								<td>
									{{ returnedItem.amount / returnedItem.quantity }}
								</td>
								<td>
									{{ returnedItem.amount }}
								</td>
							</tr>
							<tr>
								<td
									colspan="4"
									style="text-align: right; padding-right: 100px;"
								>
									Total
								</td>
								<td>
									{{ returnedItemsTotalAmount }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
				<textarea
					v-model="orderToUpdate.comments"
					:disabled="enableOnStatusRecievedOpen"
					class="w-full mt-6 h-32 border-solid border-gray-300 border"
					placeholder="Any Other comments"
				/>
			</el-col>
		</el-row> -->

		<div class="mt-4 mb-6">
			<p class="mb-1 font-semibold">Special Instruction</p>
			<textarea
				v-model="orderToUpdate.special_instruction"
				rows="3"
				class="p-2"
				style="min-width: 400px; max-width:500px; border: 1px solid #ddd;"
				placeholder="Any intruction provide at order"
			></textarea>
			<!-- <BaseInput
				v-model="orderToUpdate.special_instruction"
				:disabled="isOrderDisabled"
				class="baseInput"
				style="min-width: 300px; max-width:400px;"
				custom-class="p-2 text-sm  text-amp-input-boxes"
				placeholder="Any intruction provide at order"
			/> -->
		</div>

		<div class="flex justify-end">
			<!-- <div class="button-child">
				<BaseButton
					type="submit"
					buttonclass="btn p-2.5 text-sm"
					:disabled="isOrderDisabled"
				>
					Edit
				</BaseButton>
			</div>
			<div class="button-child">
				<BaseButton type="submit" buttonclass="btn p-2.5 text-sm">
					Export
				</BaseButton>
			</div>
			<div class="button-child">
				<el-select
					v-model="orderStatus"
					style="min-width: 100%"
					placeholder="Update Order Status"
				>
					<el-option
						v-for="(status, statusIndex) in orderStatusOptions[
							orderToUpdate.status
						]"
						:key="statusIndex"
						:label="status.label"
						:value="status.value"
					></el-option>
				</el-select>
			</div> -->
			<div class="w-32 mr-4">
				<BaseButton
					type="submit"
					buttonclass="btn p-2 text-sm"
					@click="$emit('closePopup')"
				>
					Cancel
				</BaseButton>
				<!-- :disabled="isOrderDisabled" -->
			</div>
			<div class="w-32">
				<BaseButton
					type="submit"
					buttonclass="btn p-2 text-sm"
					@click="saveUpdatedOrder"
				>
					Save
				</BaseButton>
				<!-- :disabled="isOrderDisabled" -->
			</div>
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import InventoryService from "../../../../../services/inventoryService";
import { resolve, reject } from "q";
import moment from "moment";
const disableEditing = [
	"dispatched",
	"recieved_open",
	"recieved_closed",
	"cancelled"
];
export default {
	name: "SentOrderUpdatePopUp",
	components: {
		simplebar
	},
	props: {
		orderToUpdate: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			delivery: "",
			actualItems: [],
			returnedItems: [],
			orderStatus: this.orderToUpdate.status,
			batchExpiryNotRequired: ["created", "sent", "accepted"],
			wantToDispatchOrder: false,
			orderStatusOptions: {
				created: [
					{ label: "Created", value: "created" },
					{ label: "Sent", value: "sent" },
					{ label: "Cancelled", value: "cancelled" }
				],
				sent: [
					{ label: "Sent", value: "sent" },
					{ label: "Accepted", value: "accepted" },
					{ label: "Cancelled", value: "cancelled" }
				],
				accepted: [
					{ label: "Accepted", value: "accepted" },
					{ label: "Dispatched", value: "dispatched" }
				],
				dispatched: [
					{ label: "Dispatched", value: "dispatched" },
					{ label: "Recieved Open", value: "recieved_open" },
					{ label: "Recieved Closed", value: "recieved_closed" }
				],
				recieved_open: [{ label: "Recieved Open", value: "recieved_open" }],
				recieved_closed: [
					{ label: "Recieved Closed", value: "recieved_closed" }
				],
				cancelled: [{ label: "Cancelled", value: "cancelled" }]
			},
			datePickerOptions: {
				disabledDate(date) {
					return date <= moment().subtract(1, "day");
				}
			}
		};
	},
	computed: {
		enableOnStatusRecievedOpen() {
			return this.isOrderDisabled
				? this.orderStatus === "recieved_open"
					? false
					: true
				: false;
		},
		updatedAmount() {
			return item => {
				let updatedAmount;
				let price = item.amount;
				if (item.updatedQuantity !== "" && item.updatedPrice !== "") {
					updatedAmount = item.updatedQuantity * item.updatedPrice;
				} else if (item.updatedQuantity === "" && item.updatedPrice !== "") {
					updatedAmount = item.quantity * item.updatedPrice;
				} else if (item.updatedQuantity !== "" && item.updatedPrice === "") {
					updatedAmount = item.updatedQuantity * price;
				} else {
					updatedAmount = item.quantity * price;
					item.updatedAmount = updatedAmount.toFixed(2);
				}
				return updatedAmount.toFixed(2);
				// let updatedAmount;
				// let price = item.amount / item.quantity;
				// if (item.updatedQuantity !== "" && item.updatedPrice !== "") {
				// 	updatedAmount = item.updatedQuantity * item.updatedPrice;
				// } else if (item.updatedQuantity === "" && item.updatedPrice !== "") {
				// 	updatedAmount = item.quantity * item.updatedPrice;
				// } else if (item.updatedQuantity !== "" && item.updatedPrice === "") {
				// 	updatedAmount = item.updatedQuantity * price;
				// } else updatedAmount = item.quantity * price;
				// item.updatedAmount = updatedAmount.toFixed(2);
				// return updatedAmount.toFixed(2);
			};
		},
		returnedItemsTotalAmount() {
			return this.returnedItems.reduce((acc, item) => {
				return (acc += item.amount);
			}, 0);
		},
		actualItemsTotalAmount() {
			return this.actualItems.reduce((acc, item) => {
				return (acc += item.updatedAmount);
			}, 0);
		},
		isOrderDisabled() {
			return disableEditing.indexOf(this.orderToUpdate.status) > -1;
		},
		totalOrderAmount() {
			return this.actualItemsTotalAmount - this.returnedItemsTotalAmount;
		},
		// disableSplitOrder() {
		// 	return this.orderToUpdate.status !== "accepted";
		// },
		callOrderUpdateApi() {
			return [
				"created",
				"sent",
				"accepted",
				"dispatched",
				"recieved_open"
			].some(status => this.orderStatus === status);
		},
		disableBatchExpiry() {
			return (
				this.isOrderDisabled ||
				["created", "sent", "accepted", "cancelled"].some(
					status => this.orderStatus === status
				)
			);
		}
	},
	created() {
		this.actualItems = this.orderToUpdate.items.filter(
			item => item.is_return === false
		);

		this.returnedItems = this.orderToUpdate.items.filter(
			item => item.is_return === true
		);
	},

	methods: {
		checkStatus(status) {
			console.log(status);
			if(status == "dispatched") {
				this.actualItems.forEach(el => {
					let date = new Date(this.orderToUpdate.date_estimated);
					el.batch_number = this.orderToUpdate.created_on.replace(/-/g, "") + el.item_info.article.code + "A" + new Date().getMinutes();
					el.expiry_date = moment(date.setDate(date.getDate() + el.item_info.article.primary_shelf_life - 1)).format("YYYY-MM-DD");
				})

			}
		},
		async saveUpdatedOrder() {
			const validationResult = await this.$validator
				.validateAll()
				.then(result => result);

			// console.log("validation result", validationResult);
			if (validationResult) {
				if (
					this.orderToUpdate.status === "accepted" &&
					this.orderStatus === "accepted"
				) {
					this.$alert(
						"Do you want to change the Status to Dispatched",
						"Confirm Status",
						{
							confirmButtonText: "OK",
							showCancelButton: true,

							callback: function(action) {
								if (action === "confirm") {
									new Promise((resolve, reject) => {
										// setTimeout(() => {
										this.orderStatus = "dispatched";
										return resolve(true);
										// }, 0);
									})
										.then(() => {
											return this.$validator
												.validateAll()
												.then(result => resolve(result));
											// validationResult = false;
										})
										.then(validationResult => {
											console.log(
												"validation result deep inside",
												validationResult
											);
											if (validationResult) {
												return this.saveOrderFuncSequence({
													orderStatus: this.orderStatus
												}).then(status => {
													return resolve(status);
												});
											}
										})
										.then(isOrderDispatched => {
											if (isOrderDispatched) {
												this.orderToUpdate.status = this.orderStatus;
												this.$emit("closePopup");
												this.$notify.success({
													title: "Success",
													message: "Order updated"
												});
											}
										});
								}
							}.bind(this)
						}
					);
				} else {
					var isOrderDispatched = await this.saveOrderFuncSequence({
						orderStatus: this.orderStatus
					}).then(status => {
						// console.log("status after saveOrderFuncSequence", status);
						return status;
					});
					if (isOrderDispatched) {
						this.orderToUpdate.status = this.orderStatus;
						this.$emit("closePopup");
						this.$notify.success({
							title: "Success",
							message: "Order updated"
						});
					}
				}

				// this.orderStatusUpdate(this.orderStatus);
			}
			// if (this.actualItems.map(item)
		},
		async saveOrderFuncSequence({ orderStatus } = {}) {
			var updateOrderStatus, updateItemsStatus, orderStatusUpdateStatus;
			// var doNotCallUpdateOrder =
			// 	this.orderToUpdate.status === "dispatched" &&
			// 	this.orderStatus === "recieved_closed";
			// const validationResult = await this.$validator
			// 	.validateAll()
			// 	.then(result => result);

			// console.log("validation result", validationResult);
			// if (validationResult) {
			// debugger;
			if (this.callOrderUpdateApi) {
				updateOrderStatus = await this.updateOrder().then(status =>
					resolve(status)
				);
			} else {
				updateOrderStatus = true; // if api is not called then set it by default.
			}

			// let splitStatus = await this.saveAllSplittedOrders(
			// 	this.actualItems.map(this.extractItem)
			// ).then(v => resolve(v));
			// console.log("splitStatus", splitStatus);
			updateItemsStatus = await this.updateItems().then(status => status);

			orderStatusUpdateStatus = await this.orderStatusUpdate(orderStatus).then(
				status => status
			);
			if (updateOrderStatus && updateItemsStatus && orderStatusUpdateStatus)
				return true;
			return false;
		},
		async updateItems() {
			try {
				// console.log(
				// 	this.actualItems,
				// 	this.extractItem,
				// 	this.returnedItems,
				// 	"arr",
				// 	this.actualItems
				// 		.map(this.extractItem)
				// 		.concat(this.returnedItems.map(this.extractItem))
				// );
				var updateItemsStatus = await InventoryService.updateItemsInOrder({
					orderId: this.orderToUpdate.id,
					params: this.actualItems
						.map(this.extractItem)
						.concat(this.returnedItems.map(this.extractItem))
				}).then(response => {
					// console.log("response in updateItems", response);
					if (response.status === 200) {
						return resolve(true);
					}
				});
			} catch (err) {
				console.log(err);
				if (err.response.status !== 200) {
					return resolve(false);
				}
			}
			return updateItemsStatus;
		},
		async updateOrder() {
			try {
				var updateOrderStatus = await InventoryService.updateOrder({
					orderId: this.orderToUpdate.id,
					params: {
						// amount: this.totalOrderAmount,
						...(this.orderStatus === "recieved_open" && {
							status: this.orderStatus
						}),
						// total_amount:
						// 	this.totalOrderAmount +
						// 	(this.totalOrderAmount * this.orderToUpdate.tax) / 100,
						special_instruction: this.orderToUpdate.special_instruction,
						...(this.orderToUpdate.comments !== "" && {
							comments: this.orderToUpdate.comments
						})
						// status: this.orderStatus
					}
				}).then(async response => {
					// console.log("response in updateOrder", response);
					if (response.status === 200) {
						return resolve(true);
					}
				});
			} catch (err) {
				console.log(err);
				if (err.response.status !== 200) {
					return resolve(false);
				}
			}
			return updateOrderStatus;
		},
		extractItem(item) {
			console.log("item in extract Item", item);
			return {
				// id: item.id,
				...(item.isOriginalItem
					? { id: item.id }
					: { article: item.item_info.article.id }),
				// ...(item.isItemFromSplit && { article: item.item_info.article.id }),
				// quantity: item.updatedQuantity || item.quantity,
				quantity: item.updatedQuantity ? item.updatedQuantity : item.quantity,
				// amount: item.updatedAmount || item.amount,
				amount: item.updatedPrice ? item.updatedPrice : item.amount,
				expiry_date: item.expiry_date,
				batch_number: item.batch_number,
				unit: item.unit
			};
		},
		async orderStatusUpdate(status) {
			try {
				var orderStatusUpdateStatus = await InventoryService.orderStatusUpdate({
					orderId: this.orderToUpdate.id,
					status
				}).then(response => {
					// console.log("response in orderStatusUpdate", response);
					if (response.status == 210) {
						this.$notify.success({
							title: "success",
							message: JSON.parse(response.data).message,
							dangerouslyUseHTMLString: true,
							duration: 0
						});
						this.$emit("closePopup");
					}
					if (response.status === 200) {
						return resolve(true);
					}
				});
			} catch (err) {
				if (err.response.status !== 200) {
					this.$notify.error({
						title: "Error",
						message: JSON.parse(err.response.data).msg
					});
					return resolve(false);
				}
				console.log(err);
			}
			return orderStatusUpdateStatus;
		},
		async saveAllSplittedOrders(items) {
			return await items.every(async item => {
				return await this.saveSplittedOrder(item).then(v => resolve(v));
			});
		},
		async saveSplittedOrder(item) {
			// console.log("item in saveSplittedOrder", item);
			// if (item.updatedQuantity === "") {
			// 	this.$notify({
			// 		title: "Warning",
			// 		message: "Please Enter Updated Quantity",
			// 		type: "warning"
			// 	});
			// 	return;
			// }

			try {
				return await InventoryService.splitItem({
					orderId: this.orderToUpdate.id,
					item: item
				}).then(response => {
					if (response.status === 200) {
						item.isItemFromSplit = false;
						// this.$notify.success({
						// 	title: "Success",
						// 	message: "Item Split Success"
						// });
						return true;
					}
				});
			} catch (err) {
				console.log(err);
				return false;
			}
		},
		splitOrder(actualItems, item, actualItemsIndex) {
			let existingValidationIds = actualItems.map(item => item.validationId);
			let maxValidationId = Math.max(...existingValidationIds);

			item.isItemFromSplit = true; // can be true for original item and splitted item.
			// console.log("item", item);
			let splittedItem = JSON.parse(JSON.stringify(item));
			splittedItem.validationId = maxValidationId + 1;
			splittedItem.isOriginalItem = false; // can only be true for original item.
			// console.log("spliited item", splittedItem);
			// splittedItem.isItemFromSplit = true;
			this.actualItems.splice(actualItemsIndex + 1, 0, splittedItem);
		},
		async cancelOrder() {
			try {
				await this.orderStatusUpdate("cancelled").then(response => {
					if (response.status === 200) {
						this.orderToUpdate.status = this.orderStatus;
						// this.$emit("closePopup");
						this.$notify.success({
							title: "Success",
							message: "Order Cancelled"
						});
					}
				});
			} catch (err) {
				console.log(err);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./SentOrderUpdatePopUp";
/* Tooltip container */
</style>

<style>
.SentOrderUpdatePopUp .el-button {
	min-width: 50px;
	border: none;
}
/* .el-popover.el-popper.el-popover--plain {
	word-break: normal !important;
} */

.SentOrderUpdatePopOver {
	word-break: normal !important;
}
.el-dialog__title {
	text-transform: capitalize;
	color: #ffffff;
}
.el-dialog__header {
	background: #2e323a;
	color: #ffffff;
	padding: 15px;
}
</style>
